import React, { Fragment } from 'react'

import NewBookingRowInterface from '../../interfaces/client/NewBookingRow'

import NewBookingFormRow from '../../containers/NewBookingFormRow'

interface NewBookingFormComposeRowsProps {
  departureFlightId: string
  isTOFlight: boolean
  rows: NewBookingRowInterface[]
}

export default ({
  rows,
  departureFlightId,
  isTOFlight,
}: NewBookingFormComposeRowsProps) => (
  <Fragment>
    {rows.map((row: NewBookingRowInterface) => (
      <NewBookingFormRow
        passengerId={row.passengerId}
        key={row.passengerId}
        rowId={row.rowId}
        travelClassType={row.travelClassType}
        isTOFlight={isTOFlight}
        departureFlightId={departureFlightId}
      />
    ))}
  </Fragment>
)
